import { ReactNode } from 'react';
import styled from 'styled-components';
import { ReactComponent as GotoIcon } from '@elementary/common-ui/assets/16x16/goto.svg';
import { ReactComponent as SettingsIcon } from '@elementary/common-ui/assets/20x20/settings.svg';
import { Flex, FlexColumn, IconButton } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import useNavigateWithEnv from 'shared/hooks/useNavigateWithEnv';
import { fontSize, space } from '@elementary/common-ui/style/utils';

export type Variant = 'regular' | 'big';

const LabelWrapper = styled(Typography)<{
  $variant: Variant;
}>`
  height: ${({ $variant }) => ($variant === 'big' ? '21px' : '18px')};
  color: ${({ theme }) => theme.palette.content.secondary};
  font-size: ${({ $variant }) =>
    $variant === 'big' ? fontSize('lg') : fontSize('base')};
  white-space: nowrap;
  line-height: normal;
`;

type Props = {
  title?: string;
  variant?: Variant;
  children: ReactNode;
  link?: string;
  openSettings?: () => void;
};

const ContentWithLabel = ({
  title,
  variant = 'regular',
  children,
  link,
  openSettings,
}: Props) => {
  const navigate = useNavigateWithEnv();

  return (
    <FlexColumn>
      <Flex
        gap={space('xs')}
        sx={{
          alignItems: 'center',
          marginBottom: variant === 'big' ? '12px' : '4px',
        }}
      >
        <LabelWrapper $variant={variant}>{title}</LabelWrapper>

        {link && (
          <IconButton
            sx={{
              padding: variant === 'regular' ? '0 !important' : space('xs'),
            }}
            onClick={() => {
              navigate(link);
            }}
          >
            <GotoIcon />
          </IconButton>
        )}

        {openSettings && (
          <IconButton
            sx={{ padding: 0 }}
            onClick={() => {
              openSettings();
            }}
          >
            <SettingsIcon />
          </IconButton>
        )}
      </Flex>

      {children}
    </FlexColumn>
  );
};

export default ContentWithLabel;
